export default {
      id: "LogoMirRGB-02-usage",
      viewBox: "0 0 200.02 56.07",
      url: __webpack_public_path__ + "svgsprite.svg#LogoMirRGB-02",
      toString: function () {
        return this.url;
      }
    }